import React, { FC } from 'react';

import { BotaoFlat } from 'view/component/Botao/Botao';
import { AiOutlineFileDone } from "react-icons/ai";

import { IoMdStarHalf } from 'react-icons/io';
import WatchFilledIcon from '@atlaskit/icon/glyph/watch-filled';
import { useUsuarioLogado } from 'view/component/UsuarioLogadoContext/UsuarioLogadoContext';
import { Situacoes } from 'model/solicitacao/Situacao';
import { SRText } from 'view/component/ScreenReaderText/ScreenReaderText';
import styled from 'styled-components';
import { Spacing } from 'styles/theme/Tema';
import { useAutorizacao } from 'view/component/Autorizacao/useAutorizacao';
import { AvatarUnidade } from 'view/component/AvatarUnidade/AvatarUnidade';
import { AvatarPessoaPesquisavel } from 'view/component/AvatarPessoa/AvatarPessoaPesquisavel';
import { SolicitacoesQueryParams } from 'service/api/solicitacao/ApiSolicitacoes';
import { Papel } from 'service/restricao/Papeis';


interface SolicitacoesFiltrosRapidosProps {
  onFiltrosAtualizados: (values : SolicitacoesQueryParams) => void;
  papel: Papel;
}

export const SolicitacoesFiltrosRapidos: FC<SolicitacoesFiltrosRapidosProps> = ({onFiltrosAtualizados, papel}) => {
  const usuarioLogado = useUsuarioLogado();
  const auth = useAutorizacao()
  const isSomenteUsuarioComum = papel === Papel.UsuarioComum;
  const unidade = auth.membroUnidade?.unidade

  return (
    <FiltrosRapidos>
      <SRText>Filtros rápidos</SRText>
      <BotaoFlat onClick={() => onFiltrosAtualizados({idSolicitante: [usuarioLogado.idInstitucional]})} ><AvatarPessoaPesquisavel comLink={false} exibirNome={false} idInstitucional={usuarioLogado.idInstitucional} aria-hidden={true} />solicitadas por mim</BotaoFlat>
      <BotaoFlat onClick={() => onFiltrosAtualizados({idSituacao: [Situacoes.CONCLUIDO.id]})}><IoMdStarHalf aria-hidden={true} />a avaliar</BotaoFlat>
      <BotaoFlat onClick={() => onFiltrosAtualizados({idSituacao: [Situacoes.FECHADO.id]})}><AiOutlineFileDone aria-hidden={true} />Atendidas</BotaoFlat>
      {!isSomenteUsuarioComum && <BotaoFlat onClick={() => onFiltrosAtualizados({idResponsavelTecnico: [auth.membroUnidade?.id ?? 0]})}><AvatarPessoaPesquisavel comLink={false} exibirNome={false} idInstitucional={usuarioLogado.idInstitucional} aria-hidden={true} />Atribuídas a mim</BotaoFlat>}
      <BotaoFlat onClick={() => onFiltrosAtualizados({idInteressado: [usuarioLogado.idInstitucional]})}><WatchFilledIcon label="Interessados" aria-hidden={true} />De meu interesse</BotaoFlat>
      {!isSomenteUsuarioComum && unidade && <BotaoFlat onClick={() => onFiltrosAtualizados({idUnidadeResponsavel: [unidade.id]})}><AvatarUnidade unidade={unidade} /> Da minha unidade</BotaoFlat>}
    </FiltrosRapidos>
  )
}

const FiltrosRapidos = styled.header`
  text-align: right;
  margin: ${Spacing.unit/2}px;
`;